// extracted by mini-css-extract-plugin
module.exports = {"sizingWrapper":"sizing-wrapper-module--sizingWrapper--2Ag_9"};